import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

export const Quality = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const points = [
    { n: "01", t: t("qual.t1"), d: t("qual.d1") },
    { n: "02", t: t("qual.t2"), d: t("qual.d2") },
  ];

  return (
    <section id="qualita" ref={ref} data-testid="quality-section" className="py-24 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[3/4] overflow-hidden">
            <motion.img style={{ y }} src="/img/stack.jpg" alt="Maglioni in cashmere piegati" loading="lazy" decoding="async" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 flex flex-col justify-center">
          <Reveal><Eyebrow>{t("qual.eyebrow")}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1C1917]">
              {t("qual.h2a")} <em className="text-[#9A4930]">{t("qual.h2em")}</em>{t("qual.h2b")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base md:text-lg text-[#57534E] leading-relaxed max-w-xl">{t("qual.p")}</p>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-2 gap-10 border-t border-[#E6DFD3] pt-10">
            {points.map((p, i) => (
              <Reveal key={p.n} delay={0.1 * i}>
                <div data-testid={`quality-point-${p.n}`}>
                  <span className="font-mono text-xs text-[#9A4930]">{p.n}</span>
                  <h3 className="mt-3 font-serif text-2xl text-[#1C1917]">{p.t}</h3>
                  <p className="mt-3 text-sm md:text-base text-[#57534E] leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
